import {Injectable} from "@angular/core";
import {PublicLandingPageService} from "fello-common";
import {map, switchMap, take} from "rxjs/operators";
import {AvailableLandingPageLayouts, DashboardModuleButtonAction} from "fello-model";
import {combineLatest, Observable} from "rxjs";

@Injectable()
export class PublicPURLPageService<LayoutType extends AvailableLandingPageLayouts> extends PublicLandingPageService<LayoutType> {
  purlId$ = this.activatedRoute.params.pipe(map(params => params.purlId as string));

  performCTAAction(action: DashboardModuleButtonAction, address?: string): Observable<{url: string}> {
    return combineLatest([this.landingPageConfigId$, this.purlId$]).pipe(
      take(1),
      switchMap(([landingPageConfigId, purlId]) => {
        return this.felloApiService.performPURLCTAAction(purlId, action, address, this.getReferrerUrl(), landingPageConfigId);
      })
    );
  }
}
